import { Handle, Position, useConnection } from '@xyflow/react';
import { cn } from '@/lib/utils';

/** A port's colour says what it carries: filled once it is wired, a ring while it is free to take a wire. */
export type PortTone = 'ai' | 'ai-free' | 'step' | 'step-free' | 'run' | 'value' | 'free' | 'hidden';

const TONE: Record<PortTone, string> = {
	ai: 'border-white! bg-sky-500!',
	'ai-free': 'border-sky-500! bg-white!',
	step: 'border-white! bg-violet-500!',
	'step-free': 'border-violet-400! bg-white!',
	run: 'border-white! bg-gray-600!',
	value: 'border-white! bg-gray-500!',
	free: 'border-gray-600! bg-white!',
	hidden: 'opacity-0!'
};

interface PortProps {
	id?: string;
	type: 'source' | 'target';
	side: 'left' | 'right';
	tone: PortTone;
	connectable?: boolean;
}

export const Port = ({ id, type, side, tone, connectable = true }: PortProps) => {
	// While a wire is being drawn, the ports at its other end show where it can land.
	const landing = useConnection((connection) => connection.inProgress && connection.fromHandle.type !== type);
	return (
		<Handle
			id={id}
			type={type}
			position={side === 'left' ? Position.Left : Position.Right}
			isConnectable={connectable}
			className={cn(
				'min-h-0! min-w-0! size-2.5! border-2! transition-[width,height,box-shadow]',
				TONE[tone],
				connectable && 'hover:size-3.5! [&.connectingto.valid]:size-3.5! [&.connectingto.valid]:border-white! [&.connectingto.valid]:bg-indigo-500!',
				connectable && landing && 'ring-4 ring-indigo-500/25'
			)}
		/>
	);
};
